import React, { useState } from 'react'
import styles from './Profile.module.css'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'

import { useAuth } from '../../context/AuthProvider'

const Profile = ({ reviewerProfileData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { OAuthLogout } = useAuth();
    const { name, email } = reviewerProfileData;

    function onLogout() {
        OAuthLogout()
    }

    const splitName = (name) => {
        const nameParts = name.trim().split(' ');
        if (nameParts.length > 1) {
            return {
                firstName: nameParts[0],
                lastName: nameParts[nameParts.length - 1]
            };
        }
        return {
            firstName: name,
            lastName: ''
        };
    };

    const getInitials = (name, email) => {
        const { firstName, lastName } = splitName(name);
        if (lastName) {
            return `${firstName[0]}${lastName[0]}`.toUpperCase();
        } else if (firstName) {
            return firstName[0].toUpperCase();
        }
        return email[0].toUpperCase();
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.profileContainer}>
            <div
                className={styles.profileLogo}
                onClick={toggleDropdown}
            >
                {getInitials(name, email)}
            </div>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <div className={styles.userInfo}>
                        <div className={styles.userName}>{name || 'User'}</div>
                        <div className={styles.userEmail}>{email}</div>
                    </div>
                    <Button
                        variant='contained'
                        onClick={onLogout}
                        className={styles.logoutButton}
                        sx={{
                            width: '100%',
                            bgcolor: '#264e5a',
                            textTransform: 'none'
                        }}
                    >
                        Log out
                    </Button>
                </div>
            )}
        </div>
    )
}

export default Profile;